import React from "react";
import MemberFilesDataTable from "./MemberFilesDataTable";

const MemberFilesPage = () => {
    return (
        <div className="sub-content">
            <MemberFilesDataTable />
        </div>
    );
};

export default MemberFilesPage;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/member-files/MemberFilesPage.js